import { Module, Page } from "@flexidao/dto";
import { useTenantDisplay } from "./use-tenant-display";

export const useModuleVisiblePages = (
    module: Module.CfeConnect | Module.CfeInventory | Module.Settings | Module.CfeDiagnostic,
): Array<Page> => {
    const displaySettings = useTenantDisplay();
    return displaySettings.modules[module].visibleNavigationPageIds;
};
